(function () {
  'use strict';

  function initVSBlogArticle(root) {
    if (!root || root.dataset.vsInitialized === 'true') return;

    root.dataset.vsInitialized = 'true';


    /* =====================================================
       READING TIME
    ===================================================== */

    var articleContent = root.querySelector('[data-vs-article-content]');
    var readTime = root.querySelector('[data-vs-read-time]');

    if (articleContent && readTime) {
      var text = articleContent.innerText || articleContent.textContent || '';
      var words = text.trim().split(/\s+/).filter(Boolean).length;

      var minutes = Math.max(
        1,
        Math.ceil(words / 200)
      );

      readTime.textContent = minutes;
    }


    /* =====================================================
       TABLE OF CONTENTS
    ===================================================== */

    var toc = root.querySelector('[data-vs-toc]');

    if (toc && articleContent) {

      var headings = articleContent.querySelectorAll('h2, h3');

      if (headings.length) {

        headings.forEach(function (heading, index) {

          if (!heading.id) {
            heading.id = 'vs-ba-heading-' + index;
          }

          var link = document.createElement('a');

          link.href = '#' + heading.id;
          link.textContent = heading.textContent.trim();

          if (heading.tagName.toLowerCase() === 'h3') {
            link.classList.add('vs-ba-toc-h3');
          }

          link.addEventListener('click', function (event) {
            event.preventDefault();

            var target = document.getElementById(heading.id);

            if (!target) return;

            target.scrollIntoView({
              behavior: 'smooth',
              block: 'start'
            });

            if (window.history && window.history.replaceState) {
              window.history.replaceState(
                null,
                '',
                '#' + heading.id
              );
            }
          });

          toc.appendChild(link);
        });

        var tocLinks = Array.prototype.slice.call(
          toc.querySelectorAll('a')
        );

        if ('IntersectionObserver' in window) {

          var observer = new IntersectionObserver(
            function (entries) {

              entries.forEach(function (entry) {

                if (!entry.isIntersecting) return;

                tocLinks.forEach(function (link) {
                  link.classList.remove('vs-ba-toc-active');
                });

                var active = toc.querySelector(
                  'a[href="#' + entry.target.id + '"]'
                );

                if (active) {
                  active.classList.add('vs-ba-toc-active');
                }

              });

            },
            {
              rootMargin: '-100px 0px -65% 0px',
              threshold: 0
            }
          );

          headings.forEach(function (heading) {
            observer.observe(heading);
          });

        }

      } else {

        var tocCard = toc.closest('.vs-ba-toc-card');

        if (tocCard) {
          tocCard.style.display = 'none';
        }

      }

    }


    /* =====================================================
       SOCIAL SHARE
    ===================================================== */

    var shareButtons = root.querySelectorAll('[data-vs-share]');

    shareButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        var type = button.getAttribute('data-vs-share');

        var url = window.location.href;
        var title = document.title;

        if (type === 'facebook') {

          var facebookUrl =
            'https://www.facebook.com/sharer/sharer.php?u=' +
            encodeURIComponent(url);

          window.open(
            facebookUrl,
            'vs-facebook-share',
            'width=650,height=550'
          );

        }


        if (type === 'x') {

          var xUrl =
            'https://twitter.com/intent/tweet?url=' +
            encodeURIComponent(url) +
            '&text=' +
            encodeURIComponent(title);

          window.open(
            xUrl,
            'vs-x-share',
            'width=650,height=550'
          );

        }


        if (type === 'linkedin') {

          var linkedinUrl =
            'https://www.linkedin.com/sharing/share-offsite/?url=' +
            encodeURIComponent(url);

          window.open(
            linkedinUrl,
            'vs-linkedin-share',
            'width=650,height=550'
          );

        }


        if (type === 'copy') {

          if (
            navigator.clipboard &&
            navigator.clipboard.writeText
          ) {

            navigator.clipboard.writeText(url)
              .then(function () {

                var original = button.textContent;

                button.textContent = '✓';

                window.setTimeout(function () {
                  button.textContent = original;
                }, 1500);

              })
              .catch(function () {
                fallbackCopy(url, button);
              });

          } else {

            fallbackCopy(url, button);

          }

        }

      });

    });


    /* =====================================================
       HELPFUL
    ===================================================== */

    var helpfulButtons =
      root.querySelectorAll('[data-vs-helpful]');

    var helpfulMessage =
      root.querySelector('[data-vs-help-message]');

    helpfulButtons.forEach(function (button) {

      button.addEventListener('click', function () {

        helpfulButtons.forEach(function (item) {
          item.classList.remove('vs-ba-help-selected');
        });

        button.classList.add('vs-ba-help-selected');

        if (helpfulMessage) {
          helpfulMessage.hidden = false;
        }

      });

    });


    /* =====================================================
       NEWSLETTER LOADING
    ===================================================== */

    var newsletterForms =
      root.querySelectorAll('.vs-ba-newsletter-form');

    newsletterForms.forEach(function (form) {

      form.addEventListener('submit', function () {

        var submitButton =
          form.querySelector('button[type="submit"]');

        if (!submitButton) return;

        if (submitButton.dataset.vsSubmitting === 'true') {
          return;
        }

        submitButton.dataset.vsSubmitting = 'true';

        submitButton.style.opacity = '0.65';
        submitButton.style.pointerEvents = 'none';

      });

    });

  }


  /* =======================================================
     FALLBACK COPY
  ======================================================= */

  function fallbackCopy(text, button) {

    var textarea = document.createElement('textarea');

    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';

    document.body.appendChild(textarea);

    textarea.select();

    try {
      document.execCommand('copy');

      var original = button.textContent;

      button.textContent = '✓';

      window.setTimeout(function () {
        button.textContent = original;
      }, 1500);

    } catch (error) {
      window.prompt(
        'Copy this article link:',
        text
      );
    }

    document.body.removeChild(textarea);
  }


  /* =======================================================
     INITIALIZE
  ======================================================= */

  function initAll() {

    document
      .querySelectorAll('[data-vs-blog-article]')
      .forEach(function (root) {
        initVSBlogArticle(root);
      });

  }


  if (document.readyState === 'loading') {

    document.addEventListener(
      'DOMContentLoaded',
      initAll
    );

  } else {

    initAll();

  }


  /* =======================================================
     SHOPIFY THEME EDITOR
  ======================================================= */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var root = event.target.querySelector(
        '[data-vs-blog-article]'
      );

      if (root) {
        root.dataset.vsInitialized = 'false';
        initVSBlogArticle(root);
      }

    }
  );


})();